import { render, staticRenderFns } from "./KeybindInput.vue?vue&type=template&id=3af1172d&"
import script from "./KeybindInput.vue?vue&type=script&lang=ts&"
export * from "./KeybindInput.vue?vue&type=script&lang=ts&"
import style0 from "./KeybindInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports